import { render } from "./AccordionList.vue?vue&type=template&id=44c0658c&scoped=true"
import script from "./AccordionList.vue?vue&type=script&lang=js"
export * from "./AccordionList.vue?vue&type=script&lang=js"

import "./AccordionList.vue?vue&type=style&index=0&id=44c0658c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c0658c"]])

export default __exports__